import { render, staticRenderFns } from "./customPopup.vue?vue&type=template&id=bc87f28c&scoped=true"
import script from "./customPopup.vue?vue&type=script&lang=js"
export * from "./customPopup.vue?vue&type=script&lang=js"
import style0 from "./customPopup.vue?vue&type=style&index=0&id=bc87f28c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc87f28c",
  null
  
)

export default component.exports